import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export class BoardContextGroup extends HasProjectMixin(Model) {
  declare id: number;
  declare boardContext: number;
  declare title: string;
  declare order: number;
  declare isPreview: boolean;

  static get $name() {
    return "BoardContextGroup";
  }

  static get fields() {
    return [
      "id",
      { name: "boardContext", dataSource: "board_context", type: "number" },
      "title",
      { name: "order", type: "number", defaultValue: 0 },
      { name: "isPreview", dataSource: "is_preview", type: "boolean", defaultValue: false },
    ];
  }
}

// @ts-expect-error - exposeProperties is internal method
BoardContextGroup.exposeProperties();
